import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Router from 'vue-router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import Top from '@/components/Top'
import Bus from '@/components/Bus'
import Freight from '@/components/Freight'
import Construction from '@/components/Construction'
import Safety from '@/components/Safety'
import Corporation from '@/components/Corporation'
import Recruit from '@/components/Recruit'
import RecruitNewgrads from '@/components/RecruitNewgrads'
import RecruitDriver from '@/components/RecruitDriver'

Vue.use(BootstrapVue)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Top
    },
    {
      path: '/bus',
      component: Bus
    },
    {
      path: '/freight',
      component: Freight
    },
    {
      path: '/construction',
      component: Construction
    },
    {
      path: '/safety',
      component: Safety
    },
    {
      path: '/corporation',
      component: Corporation
    },
    {
      path: '/recruit',
      component: Recruit
    },
    {
      path: '/recruit/newgrads',
      component: RecruitNewgrads
    },
    {
      path: '/recruit/driver',
      component: RecruitDriver
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js